import { Grid, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import React, { memo, useCallback, useContext, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import aircraftApi from "../../../api/aircraft.api";
import { DEBOUNCE_TIME } from "../../../Constants";
import { QuoteContextStore } from "../../../context/QuoteContext/QuoteContext";
import { debounce } from "../../../services/utils";
import { BetterControlledAutocomplete, ControlledTextField } from "../../Core/Form/ControlledFields";


const AircraftYearAutocomplete = memo(({...props}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [years, setYears] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { watch, setValue } = useFormContext();
    const { loadAircraft } = useContext(QuoteContextStore);
    const {locked_quote} = useContext(QuoteContextStore)

    const make = watch("make");
    const model = watch("model");
    const notFound = watch("make_model_not_found");

    useEffect(() => {
        setYears([]);
    }, [make, model])

    async function filter(make, model, year) {
        setIsLoading(true);
        if(!year) {
            const { data: { aircraft_years }} = await aircraftApi.getYears(make , model, "");
            setYears(aircraft_years.map(year => year.toString()));
            setIsLoading(false);
            return;
        }
        if(year.toString().length <= 0) {
            const { data: { aircraft_years }} = await aircraftApi.getYears(make , model, "");
            setYears(aircraft_years.map(year => year.toString()));
            setIsLoading(false);
            return;
        }
        const { data: { aircraft_years }} = await aircraftApi.getYears(make , model, year);
        setYears(aircraft_years.map(year => year.toString()));
        setIsLoading(false);
    }
    
    const handleOnFocus = async () => {
        setIsLoading(true);
        const { data: { aircraft_years }} = await aircraftApi.getYears(make , model, "");
        setYears(aircraft_years.map(year => year.toString()));
        setIsLoading(false);
    }
    
    const debounceHandler = useCallback(debounce(filter, DEBOUNCE_TIME), []);

    const handleFiltering = (e) => {
        if(!e) return;
        const { value } = e.target;
        debounceHandler(make, model, value);
    }

    const handleAircraftPick = async (e, value) => {
        setIsLoading(true)
        if(!model || !make || !value) return;
        const { data: aircraft } = await aircraftApi.getAircraft(make, model, value);
        await loadAircraft(aircraft);
        setValue('min_value', aircraft.min_value);
        setValue('max_value', aircraft.max_value);
        setValue('is_hangared', 'false')
        setIsLoading(false)
    }

    if (notFound) {
        return <Grid item xs={12} md={3}>
            <Typography variant="h4" className="gray">Aircraft year</Typography>
            <ControlledTextField fullWidth name="year" className="margin-top-8" placeholder="Year" disabled={locked_quote}/>
        </Grid> 
    } else {
        return (!isMobile || make && model) ? <Grid item xs={12} md={3}>
        {make && model && <>
            <Typography variant="h4" className="gray">Aircraft year</Typography>
            <BetterControlledAutocomplete isLoading={isLoading} onFocus={handleOnFocus} name="year" className="margin-top-8" type="number" onChange={handleAircraftPick} onInputChange={handleFiltering} placeholder="Year" options={years} disabled={locked_quote}/>
        </>}
        </Grid> : <div/>
    }

})

export default AircraftYearAutocomplete;